import { LabelingState } from '@/stores/slices/Labeling/types'
import { ToolType } from '@/pages/Labeling/types'
import { DEFAULT_SHORTCUTS } from '@/pages/Labeling/components/ShortcutDrawer/hotKeys'
import { LABELING_STATUS } from '@/api/LabelingNode/const'

export const ANNOTATION_GLOBAL_OPACITY = 0.8
export const OCR_GLOBAL_OPACITY = 0.2

export const initialState: LabelingState = {
  parentNodeId: '',
  labelingNodeId: '',
  projectId: '',
  classGroupId: '',
  name: '',
  modelType: 'ANOMALY_DETECTION',
  tool: {
    tool: ToolType.POINTER,
    class: null,
    shape: ToolType.RECTANGLE,
    brush: 1,
    isBrushAutoFill: false,
    isMaskingMode: false,
    opacity: ANNOTATION_GLOBAL_OPACITY * 100,
    magicWandThreshold: 16,
    autoPixelType: 'POINT',
    rgb: { all: true, red: true, green: true, blue: true },
    stamp: {
      isTracking: false,
      includeText: false,
    },
  },
  fileFilter: [],
  classTagFilters: [],
  originalFiles: [],
  files: [],
  isInProgress: false,
  isAddingClass: false,
  annotation: {},
  comments: {},
  currentIndex: 0,
  isRoiAllowed: false,
  classes: [],
  // datasetInfo: {
  //   datasetNodeId: '',
  //   name: '',
  // },
  userShortcuts: DEFAULT_SHORTCUTS,
  isReviewAvailable: false,
  userIsReviewer: false,
  userIsLabeler: false,
  reviewers: [],
  labelingMembers: [],
  userCursorColor: '',
  numOfLabelingData: 0,
  isLabelerAssigned: false,
  hasClusteringResult: false,
  hasSelectedForClustering: false,
  backupObjects: {},
  labelAssistant: {
    itemId: '',
    isRunning: false,
  },
  isRunningSemiAutoLabeling: false,
  promptImageIds: [],
  isHotkeysEnabled: true,
  reportId: '',
  jobStatus: undefined,
  showReportButton: false,
  isAuto: false,
  status: LABELING_STATUS.NOT_STARTED,
  currentTab: '',
  loadLabelingDataRequestId: '',
}

export const POSSIBLE_SHAPE = [
  ToolType.RECTANGLE,
  ToolType.ELLIPSE,
]

export const POSSIBLE_TOOL = [
  ...POSSIBLE_SHAPE,
  ToolType.POINTER,
  ToolType.POLYGON,
  ToolType.BRUSH,
  ToolType.MAGICWAND,
  ToolType.AUTOPIXEL,
  ToolType.COMMENT,
  'select',
]

export const MAX_SNAPSHOT = 50

export const CURSOR_COLORS = ['#3A4FCC', '#12828E', '#0B6F0D', '#FC6D21', '#DD2C18', '#C41162']
